export default __webpack_public_path__ + "static/media/WEATHER.f9f78347.mp3";